import gql from 'graphql-tag';
import React, { FC } from 'react';
import { useMutation } from 'urql';

import {
  Card,
  CardCloseButton,
  CardOptions,
  Form,
  SubmitButton,
  useModalContext,
} from '@/components';
import {
  PlayerGeoLocationBlockMutation,
  PlayerGeoLocationBlockMutationVariables,
  PlayerGeoLocationUnblockMutation,
  PlayerGeoLocationUnblockMutationVariables,
} from './__generated__/PlayerGeoLocationStatusForm';

const blockMutation = gql`
  mutation PlayerGeoLocationBlock($playerId: ID!) {
    blockGeoLocation(playerId: $playerId) {
      id
      geoLocationBlockStatus {
        status
      }
    }
  }
`;

const unblockMutation = gql`
  mutation PlayerGeoLocationUnblock($playerId: ID!) {
    unblockGeoLocation(playerId: $playerId) {
      id
      geoLocationBlockStatus {
        status
      }
    }
  }
`;

const PlayerGeoLocationStatusForm: FC<{
  playerId: string;
  status: string;
}> = ({ playerId, status }) => {
  const isBlocked = status !== 'NotBlocked';

  const [blockPlayerGeoLocationState, blockPlayerGeoLocation] = useMutation<
    PlayerGeoLocationBlockMutation,
    PlayerGeoLocationBlockMutationVariables
  >(blockMutation);

  const [unblockPlayerGeoLocationState, unblockPlayerGeoLocation] = useMutation<
    PlayerGeoLocationUnblockMutation,
    PlayerGeoLocationUnblockMutationVariables
  >(unblockMutation);

  const { close } = useModalContext();

  const onSubmit = () => {
    const mutate = isBlocked
      ? unblockPlayerGeoLocation
      : blockPlayerGeoLocation;

    mutate({ playerId }).then(() => {
      if (close) {
        close();
      }
    });
  };

  const fetching = isBlocked
    ? unblockPlayerGeoLocationState.fetching
    : blockPlayerGeoLocationState.fetching;

  return (
    <Card
      size="lg"
      title="Geo Location Status"
      options={
        <CardOptions>
          <CardCloseButton />
        </CardOptions>
      }
    >
      <div className="p-3">
        <Form
          defaultValues={{}}
          onSubmit={onSubmit}
          className="grid grid-cols-2 sm:grid-cols-3 gap-6"
        >
          <SubmitButton
            value={isBlocked ? 'Unblock Geo Location' : 'Block Geo Location'}
            disabled={fetching}
          />
        </Form>
      </div>
    </Card>
  );
};

export default PlayerGeoLocationStatusForm;
